export default "__VITE_ASSET__DO_4HQcp__"